import { render, staticRenderFns } from "./courses-edit.vue?vue&type=template&id=54cfae8c"
import script from "./courses-edit.vue?vue&type=script&lang=js"
export * from "./courses-edit.vue?vue&type=script&lang=js"
import style0 from "./courses-edit.vue?vue&type=style&index=0&id=54cfae8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports